import { IKlantGroepModel } from 'shared/models/IKlantGroepModel'
import { IKlantGroepSelectie } from 'shared/models/IKlantGroepSelectie'
import { IProductType } from 'shared/models/IProductType'

export const isCheckboxSelected = (
  checkboxValue: string | undefined,
  value: number
): boolean => {
  if (!checkboxValue) return false
  return checkboxValue.split(',').includes(value.toString())
}

export const toggleCheckbox = (
  currentValue: string | undefined,
  value: number
): string => {
  const values = currentValue
    ? currentValue.split(',').filter(v => v !== '')
    : []
  const stringValue = value.toString()

  let updatedValues: string[]
  if (values.includes(stringValue)) {
    updatedValues = values.filter(v => v !== stringValue)
  } else {
    updatedValues = [...values, stringValue]
  }

  return updatedValues.sort((a, b) => Number(a) - Number(b)).join(',')
}

export const getInitialDays = () => {
  return [
    { day: 1, selected: false },
    { day: 2, selected: false },
    { day: 3, selected: false },
    { day: 4, selected: false },
    { day: 5, selected: false },
    { day: 6, selected: false },
    { day: 0, selected: false },
  ]
}

/**
 * Validates that default time periods cover all required combinations of:
 * - Order types (30, 32, 33, 34, 50)
 * - Days (Mon-Sun)
 * - Product types (or 'A' for all products)
 *
 * @returns Empty string if valid, error message if validation fails
 */
export const validateDefaultTimeSlots = (
  klantGroepen: IKlantGroepModel[] | null,
  selectie: IKlantGroepSelectie,
  days: { day: number; selected: boolean }[],
  productTypes: { productType: IProductType; selected: boolean }[]
): string => {
  if (!klantGroepen || (selectie.code && selectie.code !== '')) {
    return ''
  }

  const melding = 'Een of meerdere default tijdvakken zijn niet gedefinieerd '
  const orderTypeNumStrings = ['30', '32', '33', '34', '50']

  const defaultGroepen = klantGroepen.filter(t => t.defaultIndicatie === 'J')

  if (!defaultGroepen.length) {
    return melding
  }

  // Check for missing combinations of orderType × day × productType
  // Return the last missing combination
  let warning = ''

  for (const type of orderTypeNumStrings) {
    for (const day of days) {
      // First check: Does this orderType + day combination exist at all?
      if (
        defaultGroepen
          .filter(t => t.orderType.includes(type))
          .filter(u => u.dagen.includes(day.day.toString())).length === 0
      ) {
        warning = `${melding} (o.a. ordertype ${type})`
        break
      }

      // Second check: Is there a "All products" (productType 'A') for this combo?
      if (
        defaultGroepen
          .filter(t => t.productType === 'A')
          .filter(t => t.orderType.includes(type))
          .filter(u => u.dagen.includes(day.day.toString())).length === 0
      ) {
        // No "All products" entry, so check each individual product type
        for (const productString of productTypes) {
          if (
            defaultGroepen
              .filter(t =>
                t.productType.includes(productString.productType.value)
              )
              .filter(t => t.orderType.includes(type))
              .filter(u => u.dagen.includes(day.day.toString())).length === 0
          ) {
            warning = `${melding} (o.a. ordertype ${type} producttype ${productString.productType.name})`
            break
          }
        }
        break
      }
    }
  }

  return warning
}

export const getInitialProducts = () => {
  return [
    { productType: { value: 'B', name: 'Bloemen' }, selected: false },
    { productType: { value: 'P', name: 'Planten' }, selected: false },
  ]
}
